import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { useFormContext } from 'modules/client/common/forms/bankAccountsForm';

interface Props {
  index: number;
  onRemoveBankAccount?: (index: number) => void;
}

export const Header = ({ index, onRemoveBankAccount }: Props) => {
  const { t } = useTranslation();
  const { readOnly } = useFormContext();

  const isFirst = index === 0;

  const isRemoveButtonVisible = !readOnly && onRemoveBankAccount && !isFirst;

  return (
    <Stack direction="row" spacing={12}>
      <Typography variant="bodyBold">
        {t(
          isFirst
            ? 'client.client.bankAccounts.account'
            : 'client.client.bankAccounts.accountOther'
        )}
      </Typography>
      {isRemoveButtonVisible && (
        <IconButton
          colorVariant="red"
          icon={<Icon.Minus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={() => onRemoveBankAccount?.(index)}
        />
      )}
    </Stack>
  );
};
